import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import {
  BookingCalendarViewMode,
  bookingCalendarViewModeAtom,
} from "@ryde/shared";

export const CalendarViewModeSwitch: FC = () => {
  const { t } = useTranslation();

  const [viewType, setViewType] = useRecoilState(bookingCalendarViewModeAtom);

  const handleViewTypeChange = (
    event: SelectChangeEvent<BookingCalendarViewMode>,
  ): void => {
    setViewType(event.target.value as BookingCalendarViewMode);
  };

  return (
    <FormControl sx={{ minWidth: 160 }} size="small" variant="standard">
      <Select
        className={clsx({
          "calender-view-mode-switch_highlighted":
            viewType !== BookingCalendarViewMode.AllPassengers,
        })}
        data-e2e="bookings-view-mode-select"
        value={viewType}
        onChange={handleViewTypeChange}
      >
        <MenuItem value={BookingCalendarViewMode.AllPassengers}>
          {t("selectListLabel.AllPassengers")}
        </MenuItem>
        <MenuItem value={BookingCalendarViewMode.WithBookings}>
          {t("selectListLabel.WithBookings")}
        </MenuItem>
        <MenuItem value={BookingCalendarViewMode.WithoutBookings}>
          {t("selectListLabel.WithoutBookings")}
        </MenuItem>
      </Select>
    </FormControl>
  );
};
